export default __webpack_public_path__ + "static/media/Button_3-min.68db25e8.png";